import { render, staticRenderFns } from "./company_index.vue?vue&type=template&id=77892a48&scoped=true"
import script from "./company_index.vue?vue&type=script&lang=js"
export * from "./company_index.vue?vue&type=script&lang=js"
import style0 from "./company_index.vue?vue&type=style&index=0&id=77892a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77892a48",
  null
  
)

export default component.exports